module.exports = __webpack_public_path__ + "static/media/daily-goals-dark.beb3eb09.svg";